import { Permission } from '@cims-online/shared'
import { RestoreRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { simpleRestoreNotification } from 'hooks/notificationHandler'
import { useRestoreRfiResponseDisciplineMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import {
  RFIResponseDiscipline,
  useResponseDisciplinesTableContext,
} from '../../../../ResponseDisciplinesTableContext'

export function useRestoreOptions(): RestoreRowActionOptions<RFIResponseDiscipline> {
  const { refetch } = useResponseDisciplinesTableContext()
  const [restoreResponseDiscipline] = useRestoreRfiResponseDisciplineMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      restoreRFIResponseDiscipline: {
        responseDiscipline: { name },
      },
    }) => simpleRestoreNotification(name),
  })
  return {
    permission: Permission.RemoveRestoreRFIResponseDiscipline,
    onRestore: async ({ id }) => {
      await restoreResponseDiscipline({ variables: { id } })
      refetch()
    },
    metadata: ({ deleted, deletedUser, deletedDate }) => ({
      removed: deleted,
      removedBy: deletedUser,
      removedDate: deletedDate,
    }),
    default: 'active',
  }
}
